"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArrayPopulated = exports.isPopulated = exports.ObjectIdString = exports.ObjectId = exports.Document = void 0;
var zod_1 = require("zod");
var ObjectId;
var Document;
if (typeof window === 'undefined') {
    // Import Mongoose ObjectId only in the backend environment
    var mongoose = require('mongoose');
    exports.ObjectId = ObjectId = mongoose.Types.ObjectId;
    exports.Document = Document = mongoose.Document;
}
else {
    var PlaceholderObject = /** @class */ (function () {
        function PlaceholderObject() {
        }
        return PlaceholderObject;
    }());
    exports.ObjectId = ObjectId = PlaceholderObject;
    exports.Document = Document = PlaceholderObject;
}
var objectIdRegex = /^[0-9a-fA-F]{24}$/;
var ObjectIdString = function (validationErrorMessage, requiredErrorMEssage) {
    return zod_1.z
        .string({ required_error: requiredErrorMEssage })
        .refine(function (value) { return objectIdRegex.test(value); }, { message: validationErrorMessage });
};
exports.ObjectIdString = ObjectIdString;
var isObjectIdValue = function (obj) {
    if (!obj || typeof obj !== 'object')
        return false;
    if (obj._bsontype === 'ObjectID' || obj._bsontype === 'ObjectId')
        return true;
    try {
        return ObjectId ? obj instanceof ObjectId : false;
    }
    catch (_a) {
        return false;
    }
};
var isPopulated = function (obj) { return !!obj && typeof obj === 'object' && !isObjectIdValue(obj); };
exports.isPopulated = isPopulated;
var isArrayPopulated = function (array) { return Array.isArray(array) && array.length > 0 && (0, exports.isPopulated)(array[0]); };
exports.isArrayPopulated = isArrayPopulated;
//# sourceMappingURL=ObjectId.js.map